module.exports = __webpack_public_path__ + "fonts/fa-v2-light-300.0dc9a6cb.woff";